import {
  AutocompleteInput,
  Create,
  DateInput,
  NumberInput,
  SimpleForm,
} from 'react-admin';
import React, { useEffect, useState } from 'react';
import { endOfMonth, format } from 'date-fns';
import { API_HOST } from '../config';
import { getToken } from '../core/auth.store';

export const InvoiceCreate = (props) => {
  const [names, setNames] = useState<{ id: string; name: string }[]>([]);

  useEffect(() => {
    const fetchData = async () => {
      const response = await fetch(`${API_HOST}/contract/names`, {
        method: 'GET',
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
      });
      const data = await response.json();

      setNames(data);
    };

    fetchData();
  }, []);

  return (
    <Create {...props}>
      <SimpleForm redirect="list">
        <AutocompleteInput
          source="contractId"
          label="Договор"
          choices={names}
        />
        <NumberInput source="amount" label="Сумма" />
        <DateInput
          label="Срок окончания"
          source="dateEnd"
          defaultValue={format(endOfMonth(new Date()), 'yyyy-MM-dd')}
        />
      </SimpleForm>
    </Create>
  );
};
